"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
// import { regionUrl } from './config'
var interface_utils_1 = require("@uip-alpha/interface-utils");
exports.init = function (configs) { return function (UIP) {
    var http = interface_utils_1.shallowClone(UIP.http);
    var map = new WeakMap();
    /** 单独设置环境变量并覆盖 */
    if (configs && configs.mode) {
        http._env = configs.mode;
        delete configs.mode;
    }
    /**
     * 修改http request方法(对应get，post，jsonp都会更改)
     * 统一优化请求方法，比如缓存请求(防止重复提交)
     *  */
    http.request = function (conf) {
        /** 防重复提交 */
        if (map.has(conf))
            return map.get(conf);
        var promise = UIP.http
            /** 合并http全局配置 */
            .request(__assign({ headers: __assign(__assign({}, http._headers), configs) }, conf))
            .then(function (res) {
            map.delete(conf);
            return Object(res ? res.data : res);
        })
            .catch(function (e) {
            map.delete(conf);
            console.error(e);
            return Promise.resolve();
        });
        map.set(conf, promise);
        return promise;
    };
    return http;
}; };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/interface-date/dist/common/init.js
// module id = 7W69
// module chunks = 1